import { Coin } from '@/ui/icons';

export const CoinGlyph = ({ size = 16 }: { size?: number }) => <Coin size={size} />;
